<template>
  <div>
    <main>
      <section class="main-title">
        <h1>子アカウント編集<span class="small"> - 確認</span></h1>
      </section>

      <form @submit.prevent="updateUser">
        <!-- 子アカウント-->
        <section class="chapter white-block">
          <div class="form-wrap d-flex">
            <div class="left-col">
              <img v-if="user.image_attributes.filename" class="thumbnail-frame img180 mx-auto mb-3"
                :src="user.presigned_url"
                :alt="user.image_attributes.filename"
              />
              <img
                v-else-if="!!(user.uploaded_image)"
                class="thumbnail-frame img180 preview-item-file"
                :src="user.uploaded_image"
                :alt="user.new_image_name"
              />
              <img v-else
                class="thumbnail-frame img180 mx-auto mb-3"
                src="~images/ep_user_default.png"
                alt="画像が選択されていません"
              />
            </div>
            <div class="right-col">
              <dl class="form-group form-confirm-group">
                <dt>氏名</dt>
                <dd wovn-ignore>{{fullName(user)}}</dd>
              </dl>
              <dl class="form-group form-confirm-group">
                <dt>氏名（フリガナ）</dt>
                <dd wovn-ignore>{{fullKanaName(user)}}</dd>
              </dl>
              <dl class="form-group form-confirm-group">
                <dt>メールアドレス（ログインID）</dt>
                <dd wovn-ignore>{{user.email}}</dd>
              </dl>
              <dl class="form-group form-confirm-group">
                <dt>役職名</dt>
                <dd>{{user.position}}</dd>
              </dl>
              <dl class="form-group form-confirm-group">
                <dt>部署名</dt>
                <dd>{{user.department}}</dd>
              </dl>

              <dl class="form-group form-confirm-group">
                <dt>プロフィール</dt>
                <dd>{{user.profile}}</dd>
              </dl>
            </div>
          </div>
        </section>
        <!-- 子アカウント-->
        <div class="btn-container d-flex justify-content-center">
          <button class="button-square btn-cancel" type="button" @click="onClickBackPage()">修正する</button>
          <button class="button-square btn-send" type="submit">更新する</button>
        </div>
      </form>
    </main>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: '子アカウント編集',
    },
    props: {
      user: Object,
    },
    created: function(){
      this.setUserId();
    },
    methods: {
      updateUser: function(){
        this.$loading.load(this.$auth.api.patch(`ep/ep_person_in_charges/${this.user.id}`, {
          user: this.user
        })
        .then(res => {
          this.$store.commit('ep_person_in_charge/initUser');
          this.$router.push({path: `/ep/ep_person_in_charges/${this.$route.params.id}/detail` , query: {toast_type: 'updated'}});
        })
        .catch(error => {
          if(error.response.status == 500) {
            this.$errorHandlers.initial(error);
          }else{
            this.$errorHandlers.ajax(error);
          }
        }));
      },
      setUserId: function (){
        this.user.id = this.$route.params.id;
      },
      fullName: function (user) {
        return `${user.last_name} ${user.first_name}`
      },
      fullKanaName: function (user) {
        return user.kana_last_name == '' || user.kana_last_name == null ? '' : `${user.kana_last_name} ${user.kana_first_name}`
      },
      toBoolean: function(value) {
        value = typeof(value) == 'string' ? value.toLowerCase() : value
        return (value == true || value == 'true') ? true : false
      },
      onClickBackPage: function () {
        this.user.password = null;
        this.user.password_confirmation = null;
        this.$router.push({name: 'EpPersonInChargeEditForm'});
      },
    },
  }
</script>
